import React, {Fragment} from 'react'
import {GlobalStyle} from './globalStyles/GlobalStyles'
import {AppContainer} from './globalStyles/indexStyles'
import { BrowserRouter,  Route,Switch } from 'react-router-dom'
import {Footer} from './components/Footer'
import {Home} from './pages/home'
import {Evento} from './pages/evento'
import {Login} from './pages/login'
import {Moderator} from './pages/moderator'
import Context from './Context'
import varglobals from './globals';
import globals from 'react-global-configuration';

globals.set(varglobals)


export const App = (props) => {

   return <AppContainer> 
   <GlobalStyle />
   <BrowserRouter basename={process.env.REACT_APP_EVENT_PATH}  preserverScrollPosition={false}>
   
   <Context.Consumer> 
     {
       ({isAuth, activateAuth, removeAuth, song, changeSong,header,getHeader}) =>
       isAuth ?
       <Fragment>
          <Switch>
            <Route path='/evento/:id' exact  render={() => (<Evento   /> )} />
            <Route path='/' exact  render={() => (<Home /> )} />
            <Route path="*">
              <div>not found</div>
            </Route>
          </Switch>
       </Fragment>
       :
       <Fragment>
       <Route path='/moderacion' exact  render={() => (<Moderator  showheader={true} /> )} />
       <Route path='/' exact  render={() => (<Login path='/' activateAuth={activateAuth}  /> )} />
      
       </Fragment>
       
       
     }
   </Context.Consumer>
   <Footer />
   </BrowserRouter>
 </AppContainer>
}

